import * as React from 'react';
import * as styles from './styles.css';

import { Header3, InlineText2 } from '@cian/ui-kit/typography';

export function ErrorScreen() {
  return (
    <div className={styles['container']}>
      <div className={styles['img']} />
      <div className={styles['title']}>
        <Header3>Ой, что-то пошло не так</Header3>
      </div>
      <div className={styles['text']}>
        <InlineText2>
          У нас не получилось загрузить данные. Попробуйте обновить страницу либо зайдите попозже
        </InlineText2>
      </div>
    </div>
  );
}
